module.exports = {"data":{"site":{"siteMetadata":{"title":"Fake Flight Tickets","siteUrl":"https://www.fakeflighttickets.com","description":"Fake Flight Ticket Generator. 100% real flight data. Present it as proof of onward travel and you are ready for your one-way flight. Do it now! $5 Only - Almost free!"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 270
// module chunks = 60335399758886 114276838955818